import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';

import { TabBar } from './interfaces/tab-bar';

@Component({
  selector: 'tiwp-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TabBarComponent implements OnInit {
  @Input() tabs: TabBar[];
  @Input() currentTabIndex: number;

  @Input() whiteSelection = false;

  @Output() change = new EventEmitter<number>();
  @Output() tabInitialized = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {
    if (this.currentTabIndex === undefined || this.currentTabIndex === null) {
      this.currentTabIndex = this.tabs && this.tabs.length ? 0 : null;
    }
    this.tabInitialized.emit(this.currentTabIndex);
  }

  changeTab(tabIndex: number): void {
    this.change.emit(tabIndex);
  }
}
